<script setup lang="ts">
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'

  const { michaelPortrait } = useIcons()
  const { isDesktopDevice } = useBreakpoint()
</script>

<template lang="pug">
.contact-me-wrapper
  .contact-me-content
    .image-portrait
      img(:src='michaelPortrait')
    .contact-me-text
      h3.contact-me-title {{ $t('helpDetails.stillQuestions') }}
      h5.contact-description
        a(href='mailto:michael@sachkundegurus.de') E-mail: michael@sachkundegurus.de
        br
        span.ketch-pr-c5 {{ $t('or') }}
        a(href='https://wa.me/493022052308', target='_blank') Whatsapp: 030 2205 2308.
  h5.available-hours {{ $t('helpDetails.availableHours') }}
  .background-overlay(v-if='isDesktopDevice')
</template>

<style lang="postcss">
  .contact-me-wrapper {
    @apply ketch-h-full ketch-flex ketch-flex-col ketch-space-y-c20 ketch-relative;
    @apply sm:ketch-items-center sm:ketch-p-c20 sm:ketch-justify-center;

    .contact-me-content {
      @apply ketch-flex ketch-items-center ketch-space-x-c10 ketch-z-[2] md:ketch-space-x-c20;

      .image-portrait {
        img {
          @apply ketch-w-[60px] ketch-h-[60px] ketch-rounded-full md:ketch-w-[120px] md:ketch-h-[120px];
        }
      }

      .contact-me-text {
        @apply ketch-flex ketch-flex-col sm:ketch-space-y-c5;

        .contact-me-title {
          @apply ketch-font-bold;
        }
      }
    }

    .available-hours {
      @apply ketch-z-[2];
    }

    .background-overlay {
      @apply ketch-absolute ketch-inset-0 ketch-w-[180px] ketch-h-[180px];
      @apply ketch-mt-0 !important;
      background: linear-gradient(135deg, #e6e6ec 50%, var(--tertiary-color) 50%);
    }
  }
</style>
